module.exports = __webpack_public_path__ + "static/media/Figure11.dc3a63a9.jpg";